import { t as r } from "./index813.mjs";
var F = r, e = Math.min, a = function(n) {
  var t = F(n);
  return t > 0 ? e(t, 9007199254740991) : 0;
};
export {
  a as t
};
